import WelcomeContent from "containers/Welcome";

export default WelcomeContent;
